import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const calendarTradeLoadsQueryAtom = createQueryAtomFactory(
  'calendar.tradeLoads',
  (params: { fromDate: string; toDate: string; facilityId?: string }) => {
    const filter: Record<string, unknown> = {
      fromExpectedShipDate: params.fromDate,
      toExpectedShipDate: params.toDate,
    };

    if (params.facilityId) {
      filter.facilityIds = [params.facilityId];
    }

    return {
      loads: {
        __args: {
          filter,
          pagination: {
            limit: 500,
            offset: 0,
          },
        },
        entries: {
          id: true,
          documentNumber: true,
          status: true,
          expectedShipDate: true,
          facilityId: true,
          facility: {
            id: true,
            facilityName: true,
          },
        },
        page: {
          total: true,
        },
      },
    };
  },
);
